import { TranslationDataType } from 'resources/translation';

import { getValidationConstructor } from './validationConstructor';

export const getNumberValidation = (t: TranslationDataType) => ({
  standart: getValidationConstructor(t, /^[0-9]*$/, 'must_contain_only_digits'),
  withSpaces: getValidationConstructor(t, /^[0-9\s]*$/, 'must_contain_only_digits'),
});
